import classnames from 'classnames';
import React, { FC } from 'react';
import { Color } from '../../../constants/Color';
import styles from './ColorIndicator.scss';
import { IOuter } from './ColorIndicator.types';

export const ColorIndicator: FC<IOuter> = ({ color }) => (
  <span
    className={classnames(styles.wrapper, {
      [styles.anyColor]: color === Color.Any,
      [styles.bwColor]: color === Color.BlackWhite,
    })}
    style={color !== Color.Any && color !== Color.BlackWhite ? { backgroundColor: `#${color}` } : {}}
  />
);
